import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, DestroyRef, afterNextRender, inject, signal } from "@angular/core";
import { ClientLogosComponent } from "../../components/client-logos/client-logos.component";
import { TestimonialsComponent } from "../../components/testimonials/testimonials.component";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { GetInTouchComponent } from "../../components/get-in-touch/get-in-touch.component";
import { CaseStudiesSliderComponent } from "../../components/case-studies-slider/case-studies-slider.component";

import { OurCapabilitiesGridComponent } from "../../components/our-capabilities-grid/our-capabilities-grid.component";
import { DOCUMENT, LocationStrategy } from "@angular/common";
import { embedScript, loadScript } from "@noah-ark/common";

declare const DotLottie: any;

@Component({
    selector: "in2-home-page",
    imports: [
        RouterModule,
        GetInTouchComponent,
        CaseStudiesSliderComponent,
        OurCapabilitiesGridComponent,
        ClientLogosComponent,
        TestimonialsComponent,
        GetInTouchComponent,
        // LottieComponent,
    ],
    templateUrl: "./home-page.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ["./home-page.component.scss"],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export default class HomePageComponent {
    mapSrc = signal(inject(LocationStrategy).getBaseHref() + "assets/map.json");
    constructor() {
        afterNextRender(() => {
            const video = document.querySelector("video")!;
            const placeholder = document.querySelector("img")!;

            video.addEventListener("loadedmetadata", () => {
                try {
                    video.play();
                    placeholder.style.display = "none";
                } catch (error) {
                    console.error("Error playing video:", error);
                }
            });

            this.loadDotLottie();
        });
    }

    private doc = inject(DOCUMENT);
    async loadDotLottie() {
        await embedScript(
            this.doc,
            `
            import {DotLottie} from "https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web/+esm";
            new DotLottie({
                autoplay: true,
                loop: true,
                canvas: document.getElementById("map-canvas"),
                src: "${this.mapSrc()}",
            });
            `,
            { id: "lottie", type: "module" },
        );
    }
}
